import { post, get } from 'common/axiosClient';
import { API } from 'common/constants/urls';
import { getFileUploadUrl } from '../project/project.api';

export interface SavePayappDraftDTO {
  projectId: string;
  projectDrawId: string;
  data: {
    activeStep: number;
    fileBlobName?: string;
    step1: Record<string, any> | null;
    step2: Record<string, any> | null;
    step3: Record<string, any> | null;
  };
}

export interface PayappDraftData {
  activeStep: number;
  fileBlobName?: string; // File blobName for retrieving the PDF
  step1: Record<string, any> | null;
  step2: Record<string, any> | null;
  step3: Record<string, any> | null;
}

export const savePayappDraft = async (dto: SavePayappDraftDTO) => {
  return await post(`${API.PAYAPPS}/draft`, dto);
};

export const getPayappDraft = async (projectDrawId: string): Promise<PayappDraftData> => {
  const response = await get(`${API.PAYAPPS}/draft?projectDrawId=${projectDrawId}`);
  // Parse the JSON string from the backend's data field
  const parsedData = JSON.parse(response.data);
  // Return the parsed data which should contain activeStep, step1, step2, step3
  return parsedData;
};

export const getPayappFileUrl = async (blobName: string): Promise<string> => {
  return await getFileUploadUrl(blobName);
};
